import { visserApi } from "./visserApi";
import { convertModelToFormData } from "./helpers";
const getAllArticals = async () => {
    return visserApi.get('Article/GetArticleDropdown');
};
const getArticleById = (articleId) => {
    return visserApi.get(`Article/GetArticleById/${articleId}`);
};
const getArticleNumber = async () => {
    return await visserApi.get('Article/GetArticleNumber');
};
const createArticle = async (createdArticle) => {
    return await visserApi.post('Article/Create', createdArticle);
};
const updateArticle = async (articleId, updateArticleDto) => {
    return await visserApi.put(`Article/Update/${articleId}`, updateArticleDto);
};
const getAllInStockArticles = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`Article/GetAllInStockArticle?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getAllOutOfStockArticles = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`Article/GetAllOutOfStockArticle?PageNumber=${request.pageNumber}&PageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getAllAttachmentsByArticleId = async (articleId) => {
    return await visserApi.get(`Article/GetAllAttachmentsByArticleId/${articleId}`);
};
const addAttachmentsByArticleId = (fileUploaded) => {
    const formData = convertModelToFormData(fileUploaded);
    return visserApi.postForm('Article/UploadArticleAttachment', formData);
};
const deleteArticleAttachment = (attachmentId) => {
    return visserApi.delete(`Article/DeleteArticleAttachmentById/${attachmentId}`);
};
const deleteArticleById = async (id) => {
    return await visserApi.delete(`Article/Delete/${id}`);
};
const getAllOrdersByArticleId = (articleId) => {
    return visserApi.get(`Article/GetAllOrdersByArticleId/${articleId}`);
};
const getAllArticles = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`Article/GetAllArticles?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getAllArticleLocationStockByArticleId = async (articleId) => {
    return visserApi.get(`ArticleLocationStock/GetAllArticleLocationStockByArticleId/${articleId}`);
};
const createArticleLocationStock = async (createdArticleLocationStock) => {
    return await visserApi.post('ArticleLocationStock/Create', createdArticleLocationStock);
};
const getArticleLocationStockById = (id) => {
    return visserApi.get(`ArticleLocationStock/GetArticleLocationStockById/${id}`);
};
const updateArticleLocationStock = async (updateArticleLocationStockDto) => {
    return await visserApi.put(`ArticleLocationStock/Update`, updateArticleLocationStockDto);
};
const deleteArticleLocationStock = (id) => {
    return visserApi.delete(`ArticleLocationStock/DeleteArticleLocationStock/${id}`);
};
const ArticalApi = {
    getAllArticals,
    getArticleById,
    getArticleNumber,
    createArticle,
    updateArticle,
    getAllInStockArticles,
    getAllOutOfStockArticles,
    getAllAttachmentsByArticleId,
    addAttachmentsByArticleId,
    deleteArticleAttachment,
    deleteArticleById,
    getAllOrdersByArticleId,
    getAllArticles,
    getAllArticleLocationStockByArticleId,
    createArticleLocationStock,
    getArticleLocationStockById,
    updateArticleLocationStock,
    deleteArticleLocationStock
};
export default ArticalApi;
